import axios from 'axios'

export const all = () => axios.get('v1/treatment-types')
